export type TeacherTier =
  | "Elite"
  | "TopPerformer"
  | "Strong"
  | "MeetsStandard"
  | "BelowStandard";

export type TeacherTierInfo = {
  tier: TeacherTier;
  rank: number;
  label: string;
  finalScoreRange: string;
  maxPercentOfWeeklyAvailability: number;
  badgeClassName: string;
};

export const TEACHER_TIER_INFO: Record<TeacherTier, TeacherTierInfo> = {
  Elite: {
    tier: "Elite",
    rank: 1,
    label: "Elite",
    finalScoreRange: "4.75 and above",
    maxPercentOfWeeklyAvailability: 100,
    badgeClassName: "bg-emerald-100 text-emerald-800",
  },
  TopPerformer: {
    tier: "TopPerformer",
    rank: 2,
    label: "Top performer",
    finalScoreRange: "4.50 – 4.74",
    maxPercentOfWeeklyAvailability: 90,
    badgeClassName: "bg-green-100 text-green-800",
  },
  Strong: {
    tier: "Strong",
    rank: 3,
    label: "Strong",
    finalScoreRange: "4.20 – 4.49",
    maxPercentOfWeeklyAvailability: 80,
    badgeClassName: "bg-sky-100 text-sky-800",
  },
  MeetsStandard: {
    tier: "MeetsStandard",
    rank: 4,
    label: "Meets standard",
    finalScoreRange: "4.00 – 4.19",
    maxPercentOfWeeklyAvailability: 70,
    badgeClassName: "bg-yellow-100 text-yellow-800",
  },
  BelowStandard: {
    tier: "BelowStandard",
    rank: 5,
    label: "Below standard",
    finalScoreRange: "below 4.00",
    maxPercentOfWeeklyAvailability: 30,
    badgeClassName: "bg-red-100 text-red-800",
  },
};

export const TEACHER_TIERS_FROM_BEST: TeacherTierInfo[] = Object.values(
  TEACHER_TIER_INFO,
).sort((first, second) => first.rank - second.rank);
